/** uses window.crypto.getRandomValues when defined, otherwise falls back to node environment */
export const generateUUID = (): number => {
  const idArr = new Uint32Array(8);
  if (window?.crypto?.getRandomValues) {
    return window?.crypto.getRandomValues(idArr)[0];
  } else {
    /* eslint-disable @typescript-eslint/no-var-requires */
    const { Buffer } = require('buffer');
    const crypto = require('crypto');

    const buf = Buffer.alloc(10);
    return crypto.randomFillSync(buf).toString('hex');
  }
};
